import { ServiceSheet } from '/react4xp/parts/service-sheet/service-sheet.jsx'

export default (props) => <ServiceSheet {...props} />
